import { render, staticRenderFns } from "./Treatments.vue?vue&type=template&id=64c99868&"
import script from "./Treatments.vue?vue&type=script&lang=ts&"
export * from "./Treatments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports